import { createBrowserRouter } from "react-router-dom";
import { SiteMap } from "./SiteMap";

export const router = createBrowserRouter(
  Object?.values(SiteMap)?.map((page) => ({
    path: page?.path,
    element: page?.element,
  }))
);
